export default __webpack_public_path__ + "static/media/image.vision-tech-business-solutions-pvt-ltd.861c6b27.png";